import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsTabComponent } from './abs-tab.component';
import { AbsTabGroupComponent } from './abs-tab-group.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsTabComponent, AbsTabGroupComponent],
  exports: [AbsTabComponent, AbsTabGroupComponent]
})
export class AbsTabsModule { }
